import React, { useEffect, useRef } from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { PrimaryButton } from '../../_core/_ui/buttons.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { pluralize } from '../../../lib/helpers/text.helpers';
import { messages } from './compose-panel.messages';

interface IComposeSuccessViewProps {
  // Messages accepted into the delivery queue; the enqueue IS the success.
  queuedCount: number;
  onComposeAnother: () => void;
}

// Its own component so the focus-on-mount effect runs only while the success
// view is mounted, not on every ComposePanel render.
export const ComposeSuccessView: React.FC<IComposeSuccessViewProps> = ({
  queuedCount,
  onComposeAnother
}) => {
  const composeAnotherRef = useRef<HTMLButtonElement>(null);
  // Focus "Compose another" on mount so a keyboard / screen-reader user lands on
  // the actionable affordance, not a now-unmounted field; the Drawer traps it.
  useEffect(() => {
    composeAnotherRef.current?.focus();
  }, []);

  return (
    <Box
      p={3}
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      gridGap={16}
      role="status"
      aria-live="polite"
    >
      <Typography variant="h5">
        <IntlMsg
          {...messages.queuedSuccessHeadline}
          values={{ count: queuedCount, noun: pluralize(queuedCount, 'message') }}
        />
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <IntlMsg {...messages.queuedSuccessPointer} />
      </Typography>
      <Box display="flex" gridGap={8}>
        <PrimaryButton ref={composeAnotherRef} onClick={onComposeAnother}>Compose another</PrimaryButton>
      </Box>
    </Box>
  );
};
